
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stands",
      function () {
        return require("private-next-pages/stands/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stands"])
      });
    }
  